import { useState } from "react";
import { sanitizeSearchTerm } from "src/utils/sanitize-search-term";
import { getCombinedResults } from "../utils";
import { ISearchResultsMutationVariables, useSearchResults } from "./use-search-results";

export const useQueryWithSearchResults = (mutationVariables?: ISearchResultsMutationVariables) => {
    const [query, setQuery] = useState("");

    const { results, flushResults } = useSearchResults({ queryValue: sanitizeSearchTerm(query), mutationVariables });

    const combinedResults = getCombinedResults(results);

    const onClear = () => {
        flushResults();
        setQuery("");
    };

    return {
        query,
        setQuery,
        onClear,
        results,
        combinedResults,
    };
};
